import { connect } from 'react-redux';

import { getIsLoading, isMobileMapOpen } from '../selectors';
import SearchResultsLoader from '../components/SearchResultsLoader';

export default connect(state => ({
  loading: getIsLoading(state),
  isMobileMapOpen: isMobileMapOpen(state),
}))(SearchResultsLoader);
